import React, { useEffect, useState } from 'react';
import { Container, Accordion, Table, Spinner, Alert } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/Awards.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Awards = () => {
    const navigate = useNavigate();
    const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
    const [awardsData, setAwardsData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleMemberLogin = () => navigate('/member-login');
    const handleEdcclogin = () => navigate('/edcc-login');

    // Fetch awards data (supports categoryId filter)
    useEffect(() => {
        const fetchAwards = async () => {
            try {
                setLoading(true);
                setError(null);

                // You can pass categoryId dynamically later if needed
                const response = await axios.get(
                    `${process.env.REACT_APP_BASEURL}/get-all-awards-cms`
                );

                if (response.data.success) {
                    const groupedAwards = response.data.data.reduce((acc, award) => {
                        const categoryName = award.category?.award_name || "Uncategorized";

                        if (!acc[categoryName]) acc[categoryName] = [];
                        acc[categoryName].push(award);

                        return acc;
                    }, {});

                    setAwardsData(groupedAwards);
                } else {
                    setError("Failed to load awards data");
                }

            } catch (err) {
                console.error("Error fetching awards:", err);
                setError(err.response?.data?.message || "Failed to fetch awards data");
            } finally {
                setLoading(false);
            }
        };

        fetchAwards();
    }, []);

    // Token update monitoring
    useEffect(() => {
        const interval = setInterval(() => {
            const currentToken = localStorage.getItem("token");
            if (currentToken !== tokenState) {
                setTokenState(currentToken);
            }
        }, 500);
        return () => clearInterval(interval);
    }, [tokenState]);

    return (
        <>
            {/* Hero Section */}
            <section className="hero-fixed" style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="hero-scroll-content">
                    <div className="hero-content-home poppins-regular">
                        <h1 className="hero-heading">All India Occupational Therapists' Association</h1>

                        {!tokenState && (
                            <div className="hero-buttons">
                                <button className="glass-button" onClick={handleMemberLogin}>
                                    Member Login
                                </button>
                                <button className="glass-button" onClick={handleEdcclogin}>
                                    Ergonomic Certificate login
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Content */}
            <div className="scrollable-content-home">
                <div className="content-container">
                    <section className="awards-section">
                        <Container fluid>
                            <h2 className="awards-heading">Awards & Felicitations</h2>

                            {/* Loading */}
                            {loading && (
                                <div className="text-center py-5">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                    <p className="mt-3">Loading awards data...</p>
                                </div>
                            )}

                            {/* Error */}
                            {error && (
                                <Alert variant="danger" className="my-4">
                                    {error}
                                </Alert>
                            )}

                            {/* Awards List */}
                            {!loading && !error && (
                                <Accordion defaultActiveKey="0" className="awards-accordion">
                                    {Object.entries(awardsData).map(([categoryName, awards], index) => (
                                        <Accordion.Item eventKey={index.toString()} key={index}>
                                            <Accordion.Header>{categoryName}</Accordion.Header>
                                            <Accordion.Body>
                                                {awards.length > 0 ? (
                                                    <Table responsive bordered className="awards-table">
                                                        <thead>
                                                            <tr>
                                                                <th>SI.No</th>
                                                                <th>Name</th>
                                                                <th>Place</th>
                                                                <th>Year</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {awards.map((award, idx) => (
                                                                <tr key={award._id || idx}>
                                                                    <td>{idx + 1}</td>
                                                                    <td>{award.name || 'N/A'}</td>
                                                                    <td>{award.place || 'N/A'}</td>
                                                                    <td>{award.year || 'N/A'}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                ) : (
                                                    <p className="text-muted">No awards found in this category.</p>
                                                )}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}

                                    {Object.keys(awardsData).length === 0 && (
                                        <Alert variant="info" className="my-4">
                                            No awards data available at the moment.
                                        </Alert>
                                    )}
                                </Accordion>
                            )}
                        </Container>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Awards;
